import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Tomador",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Nome",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarCliente",
    class: {
      hasErrors: _vm.clienteError,
      inputFilled: _vm.clienteFilled
    },
    attrs: {
      "filterable": false,
      "options": _vm.clients
    },
    on: {
      "input": _vm.setCliente,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.nome) + " ")]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("CPF/CNPJ: " + _vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }]),
    model: {
      value: _vm.store.formTomador,
      callback: function callback($$v) {
        _vm.$set(_vm.store, "formTomador", $$v);
      },
      expression: "store.formTomador"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("Informe o nome do cliente")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CPF/CNPJ",
      "label-for": "cnpj_cpf"
    }
  }, [_c('b-form-input', {
    key: _vm.keyToReRender,
    attrs: {
      "disabled": "",
      "id": "cnpj_cpf",
      "name": "cnpj_cpf"
    },
    model: {
      value: _vm.store.formTomador.cnpj_cpf,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTomador, "cnpj_cpf", $$v);
      },
      expression: "store.formTomador.cnpj_cpf"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-group', {
    key: _vm.keyToReRender,
    attrs: {
      "label": "Endereço",
      "label-for": "endereco"
    }
  }, [_c('VueSelect', {
    ref: "endereco",
    class: {
      hasErrors: _vm.enderecoError,
      inputFilled: _vm.enderecoFilled
    },
    attrs: {
      "filterable": false,
      "options": _vm.enderecos,
      "value": _vm.valueAdress
    },
    on: {
      "input": _vm.setEndereco,
      "search": _vm.onSearchEndereco
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        var _option$cep, _option$logradouro, _option$numero, _option$bairro, _option$cidade$cidade, _option$cidade, _option$cidade$uf, _option$cidade2;
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s("".concat((_option$cep = option.cep) !== null && _option$cep !== void 0 ? _option$cep : "", ", ").concat((_option$logradouro = option.logradouro) !== null && _option$logradouro !== void 0 ? _option$logradouro : "", ", ").concat((_option$numero = option.numero) !== null && _option$numero !== void 0 ? _option$numero : "", ", ").concat((_option$bairro = option.bairro) !== null && _option$bairro !== void 0 ? _option$bairro : "", " - ").concat((_option$cidade$cidade = option === null || option === void 0 || (_option$cidade = option.cidade) === null || _option$cidade === void 0 ? void 0 : _option$cidade.cidade) !== null && _option$cidade$cidade !== void 0 ? _option$cidade$cidade : "", " / ").concat((_option$cidade$uf = option === null || option === void 0 || (_option$cidade2 = option.cidade) === null || _option$cidade2 === void 0 ? void 0 : _option$cidade2.uf) !== null && _option$cidade$uf !== void 0 ? _option$cidade$uf : "")) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o Endereço ")])], 2)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "emissao",
      "label-for": "emissao",
      "label": "Data de emissão"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.emissao,
      callback: function callback($$v) {
        _vm.emissao = $$v;
      },
      expression: "emissao"
    }
  })], 1)], 1)], 1), _vm.store.formTomador.prestacao_fora_municipio ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("Dados do município onde serviço foi prestado:")])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CEP",
      "label-for": "store.formTomador.cep_prestado"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['#####-###'],
      expression: "['#####-###']"
    }],
    ref: "cep",
    attrs: {
      "id": "store.formTomador.cep_prestado",
      "name": "store.formTomador.cep_prestado"
    },
    model: {
      value: _vm.store.formTomador.cep_prestado,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTomador, "cep_prestado", $$v);
      },
      expression: "store.formTomador.cep_prestado"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.consultaCepCidadePretado
    }
  }, [_vm._v(" Consultar CEP ")])])], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Número",
      "label-for": "store.formTomador.numero_prestado"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "store.formTomador.numero_prestado",
      "name": "store.formTomador.numero_prestado",
      "aria-describedby": "store.formTomador.numero_prestado"
    },
    model: {
      value: _vm.store.formTomador.numero_prestado,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTomador, "numero_prestado", $$v);
      },
      expression: "store.formTomador.numero_prestado"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bairro",
      "label-for": "store.formTomador.bairro_prestado"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "store.formTomador.bairro_prestado",
      "name": "store.formTomador.bairro_prestado",
      "aria-describedby": "store.formTomador.bairro_prestado"
    },
    model: {
      value: _vm.store.formTomador.bairro_prestado,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTomador, "bairro_prestado", $$v);
      },
      expression: "store.formTomador.bairro_prestado"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Logradouro",
      "label-for": "store.formTomador.logradouro_prestado"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "store.formTomador.logradouro_prestado",
      "name": "store.formTomador.logradouro_prestado",
      "aria-describedby": "store.formTomador.logradouro_prestado"
    },
    model: {
      value: _vm.store.formTomador.logradouro_prestado,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTomador, "logradouro_prestado", $$v);
      },
      expression: "store.formTomador.logradouro_prestado"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Complemento",
      "label-for": "store.formTomador.complemento_prestado"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "store.formTomador.complemento_prestado",
      "name": "store.formTomador.complemento_prestado",
      "aria-describedby": "store.formTomador.complemento_prestado"
    },
    model: {
      value: _vm.store.formTomador.complemento_prestado,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTomador, "complemento_prestado", $$v);
      },
      expression: "store.formTomador.complemento_prestado"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cidade",
      "label-for": "formEndereco.cidade"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "cidade",
      "options": _vm.cidades_prestadas
    },
    on: {
      "input": _vm.setCidadePrestada,
      "search": _vm.onSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.cidade + " - " + option.uf) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.cidade + " - " + option.uf) + " ")])];
      }
    }], null, false, 251611044)
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome da cidade ")])], 2)], 1)], 1)], 1) : _vm._e(), _c('b-row', [_c('div', {
    staticClass: "border-bottom border-light py-3"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('p', {
    staticClass: "font-weight-bolder text-dark mb-2"
  }, [_vm._v("Calcular retenção")]), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.store.formTomador.realizar_reducao,
      expression: "store.formTomador.realizar_reducao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.store.formTomador.realizar_reducao) ? _vm._i(_vm.store.formTomador.realizar_reducao, null) > -1 : _vm.store.formTomador.realizar_reducao
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.store.formTomador.realizar_reducao,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.store.formTomador, "realizar_reducao", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.store.formTomador, "realizar_reducao", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.store.formTomador, "realizar_reducao", $$c);
        }
      }
    }
  }), _c('span')])])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.store.formTomador.cnpj_cpf && _vm.store.formTomador.cnpj_cpf.length >= 14,
      expression: "\n        store.formTomador.cnpj_cpf && store.formTomador.cnpj_cpf.length >= 14\n      "
    }],
    staticClass: "border-bottom border-light py-3"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('p', {
    staticClass: "font-weight-bolder text-dark mb-2"
  }, [_vm._v("Situação Tributária")]), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.store.formTomador.calcular_substituicao,
      expression: "store.formTomador.calcular_substituicao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.store.formTomador.calcular_substituicao) ? _vm._i(_vm.store.formTomador.calcular_substituicao, null) > -1 : _vm.store.formTomador.calcular_substituicao
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.store.formTomador.calcular_substituicao,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.store.formTomador, "calcular_substituicao", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.store.formTomador, "calcular_substituicao", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.store.formTomador, "calcular_substituicao", $$c);
        }
      }
    }
  }), _c('span')])])])], 1), _c('div', {
    staticClass: "border-bottom border-light py-3"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('p', {
    staticClass: "font-weight-bolder text-dark mb-2"
  }, [_vm._v(" Prestação fora do município ")]), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.store.formTomador.prestacao_fora_municipio,
      expression: "store.formTomador.prestacao_fora_municipio"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.store.formTomador.prestacao_fora_municipio) ? _vm._i(_vm.store.formTomador.prestacao_fora_municipio, null) > -1 : _vm.store.formTomador.prestacao_fora_municipio
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.store.formTomador.prestacao_fora_municipio,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.store.formTomador, "prestacao_fora_municipio", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.store.formTomador, "prestacao_fora_municipio", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.store.formTomador, "prestacao_fora_municipio", $$c);
        }
      }
    }
  }), _c('span')])])])], 1), _c('div', {
    staticClass: "border-bottom border-light py-3"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('p', {
    staticClass: "font-weight-bolder text-dark mb-2"
  }, [_vm._v("Retido pelo tomador")]), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.store.formTomador.retido_pelo_tomador,
      expression: "store.formTomador.retido_pelo_tomador"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.store.formTomador.retido_pelo_tomador) ? _vm._i(_vm.store.formTomador.retido_pelo_tomador, null) > -1 : _vm.store.formTomador.retido_pelo_tomador
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.store.formTomador.retido_pelo_tomador,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.store.formTomador, "retido_pelo_tomador", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.store.formTomador, "retido_pelo_tomador", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.store.formTomador, "retido_pelo_tomador", $$c);
        }
      }
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.newClient",
      modifiers: {
        "newClient": true
      }
    }],
    ref: "add_buyer",
    staticClass: "btn btn-primary font-weight-bold",
    staticStyle: {
      "font-size": "11px",
      "margin-top": "30px",
      "float": "right"
    }
  }, [_vm._v(" Novo Cliente ")])])], 1), _c('NovoClienteModal', {
    attrs: {
      "modal-id": "newClient"
    },
    on: {
      "selected": _vm.handleNovoClienteSelected
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };